import React from "react";
import {Label} from "reactstrap";
import isEmpty from 'lodash/isEmpty';
import {useTranslation} from "react-i18next";

const FieldTemplate = (
    {
        id,
        label,
        classNames,
        help,
        required,
        description,
        errors,
        children
    }
) => {
    const {t, i18n} = useTranslation();

    return <div className={classNames}>
        <Label className='control-label' htmlFor={id}>
            {t(label)}
            {(label && required) ? ' *' : null}
        </Label>
        {description}
        {children}
        {errors}
        {help}
    </div>
}

export default FieldTemplate;